import { client } from './client'
import { CustomError } from '../CustomError'

/**
 * List all organizations for a user
 * @returns
 */
export const listUserOrganizations = async (jwtToken?: string | null) => {
  const headers = {}

  if (jwtToken) {
    headers['Authorization'] = `Bearer ${jwtToken}`
  }

  const resp = await client.GET('/api/v1/organizations/mine', {
    headers,
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to list user organizations'
    throw new CustomError(resp, message)
  }

  return resp.data
}
